"use client";
import { useGetFiltersQuery } from "@/api/AppApi/services/filters";
import { queryFiltersParams } from "@/app/components/Filter";
import { useIsMobile } from "@/hooks/useIsMobile";
import { filtersAtom, backendFiltersAtom } from "@/hooks/useCurrentFilters";
import { useAtom } from "jotai";
import { useEffect } from "react";
import { usePushQueryToRouter } from "@/utils/functions/pushQueryToRouter";
import { prepareQueryToRouter } from "@/app/components/common-filter-builder/flters-helpers/filter-functions";
import ScrollContainer from "./ScrollContainer";
import FilterChip from "./FilterChip";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";

interface InlineFilterRowProps {
  searchParams: { [key: string]: string };
  categoryId?: number | string;
}

const InlineFilterRow: React.FC<InlineFilterRowProps> = ({
  searchParams,
  categoryId,
}) => {
  const { data: companyData } = useGetCompanyQuery();
  const isMobile = useIsMobile();
  const showScrollableFilter =
    companyData?.result?.theme?.components?.product?.show_scrollable_filter;

  const { data: filtersData } = useGetFiltersQuery(
    queryFiltersParams(searchParams, categoryId),
  );
  const filters = filtersData?.result;

  const [filtersIds, setFilterIds] = useAtom(filtersAtom);
  const [backendFilters, setBackendFilters] = useAtom(backendFiltersAtom);
  const { pushQueryToRouter } = usePushQueryToRouter();

  useEffect(() => {
    if (filters && filters.length > 0) {
      setBackendFilters(filters);
    }
  }, [filters, setBackendFilters]);

  const displayFilters = backendFilters.length > 0 ? backendFilters : filters;

  const shouldRender =
    isMobile &&
    showScrollableFilter &&
    displayFilters &&
    displayFilters.length > 0;

  if (!shouldRender) {
    return null;
  }

  const handleSelectionChange = (key: string, values: string[]) => {
    const updatedFilters = {
      ...filtersIds,
      [key]: values,
    };
    setFilterIds(updatedFilters);

    const filtersQuery = prepareQueryToRouter(updatedFilters);
    pushQueryToRouter(filtersQuery, true);
  };

  return (
    <div id="inline-filter-row" className="inline-filter-row">
      <ScrollContainer>
        {displayFilters?.map((filter: any) => {
          const filterKey = filter.configurations.key;
          const selectedValues = filtersIds[filterKey] || [];

          return (
            <FilterChip
              key={filterKey}
              filter={filter}
              selectedValues={selectedValues}
              onSelectionChange={handleSelectionChange}
            />
          );
        })}
      </ScrollContainer>
    </div>
  );
};

export default InlineFilterRow;
